export const DICT_CODE_PATTERN = /^[A-Z][A-Z0-9_]*$/

export const DICT_CODE_RULES = {
  required: "请输入字典编码",
  pattern: "字典编码仅支持大写字母、数字和下划线，且必须以字母开头",
  max: 64,
}
